import { useMutation, useQueryClient } from "@tanstack/react-query"

import { PERSONAL_QUOTE_QUERY_KEY } from "@/constants/query"
import { changeStatusBulkOrder, createBulkOrder, updateBulkOrder, deleteBulkOrders } from "@/http/bulkOrder"

import { useMessage } from "@/hook/useMessage"

export const usePersonalOfferMutation = () => {
    const client = useQueryClient()
    const { Success, Error, Process } = useMessage(PERSONAL_QUOTE_QUERY_KEY)

    const onSuccess = () => {
        client.invalidateQueries([PERSONAL_QUOTE_QUERY_KEY]).then()
        Success()
    }

    const onMutate = () => {
        Process()
    }

    const onError = (e: any) => {
        Error(e)
    }

    const createMutation = useMutation({
        mutationFn: createBulkOrder,
        onSuccess: () => onSuccess(),
        onMutate: () => onMutate(),
        onError: (e) => onError(e)
    })

    const updateMutation = useMutation({
        mutationFn: updateBulkOrder,
        onSuccess: () => onSuccess(),
        onMutate: () => onMutate(),
        onError: (e) => onError(e)
    })

    const changeStatusMutation = useMutation({
        mutationFn: changeStatusBulkOrder,
        onSuccess: () => onSuccess(),
        onMutate: () => onMutate(),
        onError: (e) => onError(e)
    })

    const deleteMutation = useMutation({
        mutationFn: deleteBulkOrders,
        onSuccess: () => onSuccess(),
        onMutate: () => onMutate(),
        onError: (e) => onError(e)
    })


    return {
        createMutation,
        updateMutation,
        changeStatusMutation,
        deleteMutation
    }
}